import { createRoute, redirect, Link } from '@tanstack/react-router';
import { IconChevronRight } from '@tabler/icons-react';
import { Route as appRoute } from '../../../app.js';
import { useAuthStore } from '../../../../lib/auth.js';
import { useTenantsList } from '../../../../hooks/useSharing.js';
import { AdminPageHeader } from '../../../../components/admin/AdminPageHeader.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: 'admin/tenants',
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role;
    if (role !== 'super_admin') throw redirect({ to: '/app' });
  },
  component: TenantsPage,
});

function TenantsPage() {
  const tenants = useTenantsList();

  return (
    <div>
      <AdminPageHeader
        title="Tenants"
        description="Manage which master providers and courses each agency can see."
      />

      {tenants.isLoading && <p className="text-muted">Loading…</p>}
      {tenants.error && (
        <p className="text-danger bg-danger-bg border border-danger/30 rounded-lg px-4 py-3">
          Couldn't load tenants: {(tenants.error as Error).message}
        </p>
      )}

      {tenants.data && tenants.data.tenants.length > 0 && (
        <div className="bg-white border border-line rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-cream/60 border-b border-line">
              <tr className="text-left text-muted text-xs uppercase tracking-wider">
                <th className="px-5 py-3 font-medium">Agency</th>
                <th className="px-5 py-3 font-medium">Default visibility</th>
                <th className="px-5 py-3 font-medium text-right">Sharing</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line">
              {tenants.data.tenants.map((t) => (
                <tr key={t.id} className="hover:bg-cream/30 transition-colors">
                  <td className="px-5 py-3.5 font-medium text-ink">{t.name}</td>
                  <td className="px-5 py-3.5 text-muted text-xs">
                    {t.default_master_visibility ? 'All courses visible' : 'Hidden by default'}
                  </td>
                  <td className="px-5 py-3.5 text-right">
                    <Link
                      to="/app/admin/tenants/$tenantId/sharing"
                      params={{ tenantId: t.id }}
                      className="inline-flex items-center gap-1 text-navy font-medium hover:underline"
                    >
                      Manage sharing <IconChevronRight size={14} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
